"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseNavigationComponent = /** @class */ (function () {
    function FuseNavigationComponent() {
        this.layout = 'vertical';
    }
    return FuseNavigationComponent;
}());
exports.FuseNavigationComponent = FuseNavigationComponent;
